// extracted by mini-css-extract-plugin
export default {"hi_container":"HiComponent_hi_container__bByk1","hi_text":"HiComponent_hi_text__c8qIN"};